import { useTranslation } from "react-i18next";

interface LegalSection {
  heading: string;
  paragraphs: string[];
}

const Privacy = () => {
  const { t } = useTranslation(["legal", "common"]);
  const sections = t("privacy.sections", {
    returnObjects: true,
  }) as LegalSection[];

  return (
    <div data-testid="page-privacy" className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="font-display text-3xl font-black">{t("privacy.title")}</h1>
      <p className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
        {t("privacy.placeholderNotice")}
      </p>

      <div className="mt-8 space-y-8">
        {sections.map((section) => (
          <section key={section.heading}>
            <h2 className="font-display text-xl font-black">{section.heading}</h2>
            <div className="mt-2 space-y-2 text-ink-soft">
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Privacy;
